import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';

export default function REAPage() {
  const navigate = useNavigate();
  return (
    <div className="static-page" data-testid="rea-page"><header className="static-header">
        <div className="container">
          <div className="header-content">
            <img src="/logo.png" alt="House Sharing Seniors" className="logo-image" onClick={() => navigate('/')} />
            <nav>
              <button className="btn btn-secondary" onClick={() => navigate('/properties')}>Browse Properties</button>
              <button className="btn btn-primary" onClick={() => navigate('/apply')}>Apply Now</button>
            </nav>
          </div>
        </div>
      </header>

      <section className="page-hero">
        <div className="container">
          <h1>Real Estate Agent Information</h1>
          <p>Everything real estate agents and property owners need to know about HSS Group Tenancies.</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="content-section">
            <h2>For Real Estate Agents &amp; Property Owners</h2>
            <p>Download our information packs explaining how HSS Group Tenancies work and the financial benefits for landlords and agents.</p>
            <div className="resources-grid" style={{ marginTop: '20px' }}>
              <div className="resource-card">
                <div className="resource-icon">📄</div>
                <h4>HSS REA Information Pack</h4>
                <p>Overview of HSS Group Tenancy model and benefits for real estate agents and property owners.</p>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '12px', color: '#6b7280' }}>PDF</span>
                  <a href="https://res.cloudinary.com/dcepccggr/raw/upload/v1784130767/hss/docs/HSS-REA-Info-Pack.pdf"
                     target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm">Download</a>
                </div>
              </div>
              <div className="resource-card">
                <div className="resource-icon">📊</div>
                <h4>Cost-Benefit Analysis — Re-Let vs HSS</h4>
                <p>The real cost of a premium property re-let and why an HSS Group Tenancy changes everything for landlords.</p>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '12px', color: '#6b7280' }}>PDF</span>
                  <a href="https://res.cloudinary.com/dcepccggr/raw/upload/v1784130767/hss/docs/HSS-REA-Info-Pack-CostBenefit.pdf"
                     target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm">Download</a>
                </div>
              </div>
            </div>
          </div>

          <div className="content-section">
            <h2>Why List With HSS?</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '16px', marginTop: '16px' }}>
              {[
                { icon: '💰', title: 'Stable Long-Term Income', desc: 'HSS Group Tenancies typically run 12+ months with multiple tenants, reducing vacancy risk.' },
                { icon: '🛡️', title: 'Vetted Tenants', desc: 'Every HSS member is fully vetted, reference-checked and approved before being placed.' },
                { icon: '📋', title: 'Single Lease', desc: 'One group lease, one point of contact — simpler management for agents.' },
                { icon: '🏠', title: 'Premium Properties', desc: 'HSS targets 4–6 bedroom premium homes — higher gross rent, spread across the group.' },
              ].map(f => (
                <div key={f.title} style={{ padding: '16px', background: '#f8fafb', borderRadius: '10px', borderTop: '3px solid #1a2332' }}>
                  <div style={{ fontSize: '28px', marginBottom: '8px' }}>{f.icon}</div>
                  <div style={{ fontWeight: '700', fontSize: '15px', color: '#1a2332', marginBottom: '6px' }}>{f.title}</div>
                  <div style={{ fontSize: '13px', color: '#6b7280', lineHeight: '1.5' }}>{f.desc}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="content-section" style={{ textAlign: 'center' }}>
            <h2>Get in Touch</h2>
            <p style={{ color: '#6b7280', marginBottom: '20px' }}>Interested in listing a property with HSS or want to learn more?</p>
            <a href="mailto:rea@housesharingseniors.com.au"
              style={{ display: 'inline-block', padding: '12px 28px', background: '#1a2332', color: 'white', borderRadius: '8px', fontWeight: '700', textDecoration: 'none', fontSize: '15px' }}>
              Email REA Enquiry →
            </a>
          </div>
        </div>
      </section>

      <footer className="static-footer">
        <div className="container">
          <p>&copy; 2026 House Sharing Seniors. All rights reserved.</p>
          <p className="footer-links">
            <a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms of Service</a> | <a href="/contact">Contact Us</a>
          </p>
        </div>
      </footer>
    </div>
  );
}
